import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { RateCallPayload } from '@klaro7/shared-types';

import * as callService from '../services/call.service';

export function useCallHistory(params?: { page?: number; limit?: number; status?: string; search?: string; callerId?: string; professionalId?: string }) {
  return useQuery({
    queryKey: ['call-history', params],
    queryFn: () => callService.getCallHistory(params),
  });
}

export function useCallSession(id: string | undefined) {
  return useQuery({
    queryKey: ['call-session', id],
    queryFn: () => callService.getCallSession(id!),
    enabled: !!id,
  });
}

export function useRateCall() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: RateCallPayload }) =>
      callService.rateCall(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['call-history'] });
    },
  });
}

export function useTranscription(id: string | null) {
  return useQuery({
    queryKey: ['call-transcription', id],
    queryFn: () => callService.getTranscription(id!),
    enabled: !!id,
    refetchInterval: (query) => {
      // Poll while processing
      const status = query.state.data?.transcriptionStatus;
      return status === 'processing' ? 3000 : false;
    },
  });
}
